/**
 * Taxonomía PR-C — clasificación visual de tarjetas (solo frontend).
 * No altera permisos backend ni rutas sensibles.
 */
export const CARD_CATEGORIES = {
  DISTRIBUTOR_TEAM: "distributor_team",
  BUYER_COMMERCIAL: "buyer_commercial",
  LICENSE_ADMIN: "license_admin",
  MODULES_CONTRACTED: "modules_contracted",
  BUYER_REQUESTS: "buyer_requests",
  BUYER_PREVIEW: "buyer_preview",
  PLATFORM_SAAS: "platform_saas",
  BUYER_INTERNAL_TEAM: "buyer_internal_team",
  BUYER_ACCESS_CONTROL: "buyer_access_control",
  BUYER_LICENSE_LIMITS: "buyer_license_limits",
  FISCAL_CLIENTS: "fiscal_clients",
  OPERATIONAL_CLIENTS: "operational_clients",
  TECHNICAL_TOOLS: "technical_tools",
};

export const CARD_STATUS = {
  REAL: "real",
  MOCK: "mock",
  PARTIAL: "partial",
};

/** Avisos estándar para separar conceptos en pantallas comerciales. */
export const CLASSIFICATION_NOTICES = {
  distributorUsers:
    "Equipo interno BNT (diseñador, administrador, revendedor, auxiliar comercial, soporte). No son compradores ni usuarios internos de un despacho.",
  buyerCatalog:
    "Compradores del software: prospectos, trials, activos, vencidos o suspendidos. Distinto de clientes fiscales (Visor SAT) y clientes operativos (Gestión Despacho).",
  buyerInternal:
    "Usuarios internos del comprador (dueño, supervisor, auxiliar, consulta). El diseñador puede revisar por soporte; la operación diaria vive en Gestión Despacho.",
  fiscalVsOperational:
    "Clientes fiscales = RFC en Visor SAT. Clientes operativos = cartera del módulo Despacho. Ninguno es usuario login ni comprador del software.",
};
